// extracted by mini-css-extract-plugin
export default {"VolumeSliderContainer":"VolumeSlider-module__VolumeSliderContainer--k7mFP","VolumeSlider":"VolumeSlider-module__VolumeSlider--Pp8Yk","Hidden":"VolumeSlider-module__Hidden--qoouw"};